import Vue from 'vue';
import Vuex from 'vuex';

import state from './state';
import getters from './getters';
import * as mutations from './mutations';
import actions from './actions';
import startup from './modules/startup';

Vue.use(Vuex);

export default new Vuex.Store({
    state,
    getters,
    mutations: {
        mutate(state, payload) {
            Object.assign(state, payload);
        },
        ...mutations,
    },
    modules: {
        startup,
    },
    actions: {
        triggerMutate({ commit }, payload) {
            commit('mutate', {
                ...payload,
            });
        },
        ...actions,
    },
});
